import { render, staticRenderFns } from "./set04.vue?vue&type=template&id=76733858&scoped=true&"
import script from "./set04.vue?vue&type=script&lang=js&"
export * from "./set04.vue?vue&type=script&lang=js&"
import style0 from "./set04.vue?vue&type=style&index=0&id=76733858&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76733858",
  null
  
)

export default component.exports